/****************************************************
* Module Name:  AddMfgProcessModal.js
* Project:      Pansuriya Impex Sales & Manufacturing
* Owner:        info@pansuriyaimpex.com
*
* Copyright (c) Pansuriya Impex
* All rights reserved.
****************************************************/

import ProcessMasterProxy from "../../utility/proxy/manager/manufacturingProxy/processMasterProxy";
import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import Constants from "../../utility/constants";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, Tooltip } from "@mui/material";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';
import UserProxy from "../../utility/proxy/manager/userProxy";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";

const setPropSourceData = (dataToMap) => {
    let newArr = [];
    dataToMap.map((item) => {
        let option = { value: item.id, label: item.name };
        newArr.push(option);
        return true;
    });
    return newArr;
};

const AddMfgUserProcessModal = ({
    Show,
    handleClose,
    handleSave,
    loading,
    editOperation,
    sourceData,
}) => {
    const [showError, setShowError] = React.useState(false);
    const [newUser, setNewUser] = useState(editOperation ? [{ value: sourceData.userid, label: sourceData.username }] : []);
    const [newAssignedProcess, setNewAssignedProcess] = useState(editOperation ? setPropSourceData(sourceData.assignedprocess) : []);
    const [showProcessGroupLoadSpinner, setShowProcessGroupLoadSpinner] = useState(false);
    const [processOptions, setProcessOptions] = useState([]);
    const [showUserLoadSpinner, setShowUserLoadSpinner] = useState(false);
    const [userOptions, setUserOptions] = useState([]);
    const [showUserDetailModal, setShowUserDetailModal] = useState(false);

    useEffect(() => {
        getAllProcessGroup();
        getAllEmpoyees();
    }, [])

    const getAllProcessGroup = () => {
        setShowProcessGroupLoadSpinner(true);
        ProcessMasterProxy.GetAllProcess((response) => {
            if (response) {
                if (response.length > 0)
                    setAllProcessGroupData(response);
                setShowProcessGroupLoadSpinner(false);
            }
            else {
                setShowProcessGroupLoadSpinner(false);
                setShowError(true);
            }
        }
        );
    }

    const getAllEmpoyees = () => {
        setShowUserLoadSpinner(true);
        UserProxy.GetAllActiveEmployeeMini((response) => {
            if (response) {
                setAllUserData(response);
                setShowUserLoadSpinner(false);
            }
            else {
                setShowError(true);
            }
        });
    }

    const closeErrorDialog = () => {
        setShowError(false);
    };

    const setAllProcessGroupData = (response) => {
        let optionsArray = [];
        response.map((data) => {
            let option = { value: data.id, label: data.name };
            optionsArray.push(option);
            return true;
        });

        setProcessOptions(optionsArray);
        setNewAssignedProcess(newAssignedProcess.length > 0 ? newAssignedProcess : optionsArray[0]);
    }

    const setAllUserData = (response) => {
        let optionsArray = [];
        response.map((data) => {
            let option = { value: data.id, label: data.username };
            optionsArray.push(option);
            return true;
        });
        setUserOptions(optionsArray);
        setNewUser(newUser.length > 0 ? newUser : [optionsArray[0]]);
    }

    const buttonDisable = () => {
        return (
            newAssignedProcess.length === 0 ||
            newUser.length === 0
        );
    };

    const saveData = () => {
        let userid = newUser.length > 0 ? newUser[0].value : undefined;
        let processid = Array.isArray(newAssignedProcess)
            ? newAssignedProcess.map(i => i.value)
            : [newAssignedProcess.value];

        if (handleSave) {
            handleSave(userid, processid);
        }
    }

    return (
        <Box>
            <CommonSnackbar
                show={showError}
                message={
                    <Box>
                        Add User Process validation Failed
                        <br /> Please enter complete data
                    </Box>
                }
                variant={"error"}
                autoHide={false}
                handleClose={closeErrorDialog}
                title="Validation Failure"
            />

            {showUserDetailModal ? (
                <UserDetailModal
                    show={true}
                    handleClose={() => setShowUserDetailModal(false)}
                    handleSelect={(selectedOption) => {
                        const selectedCustomers = userOptions.filter(opt =>
                            selectedOption.includes(opt.value)
                        );
                        setNewUser([selectedCustomers[0]]);
                        setShowUserDetailModal(false)
                    }}
                    userids={userOptions.map(cust => cust.value)}
                    selectedIds={newUser.length !== 0 ? [newUser.value] : []}
                    usertype={"E"}
                    loading={showUserDetailModal}
                    isMulti={false}
                />
            ) : null}

            <Modal backdrop="static" show={Show} onHide={handleClose} enforceFocus={false} >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;Add or Edit User Process
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <center>
                        <table>
                            <tbody>
                                <tr>
                                    <td style={{ width: "40%" }}>
                                        <Form.Label>
                                            User
                                            <sup style={{ color: "red" }}>*</sup>
                                        </Form.Label>
                                    </td>
                                    <td style={{ width: "100%" }}>
                                        <Select menuPlacement="auto"
                                            blurInputOnSelect={false}
                                            className="basic-single"
                                            classNamePrefix="select"
                                            value={newUser}
                                            isSearchable={true}
                                            name="Department"
                                            styles={Constants.Styles}
                                            menuPortalTarget={document.body}
                                            options={userOptions}
                                            isDisabled={editOperation}
                                            onChange={(selectedOption) => {
                                                setNewUser([selectedOption]);
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <Tooltip title="View More Data">
                                            <OpenInNewIcon
                                                style={{ fontSize: "20px", cursor: "pointer", marginLeft: "5px" }}
                                                color="action"
                                                onClick={() => {
                                                    if (!editOperation)
                                                        setShowUserDetailModal(true);
                                                }}
                                            />
                                        </Tooltip>
                                    </td>
                                    <td>
                                        {showUserLoadSpinner ? (
                                            <CircularProgress
                                                size="1em"
                                                sx={{ marginTop: "2px", ml: 0.7 }}
                                            />
                                        ) : (
                                            <Tooltip title="Reload">
                                                <RefreshOutlinedIcon
                                                    color="primary"
                                                    fontSize="medium"
                                                    onClick={() => {
                                                        if (!editOperation)
                                                            getAllEmpoyees()
                                                    }}
                                                    sx={{
                                                        cursor: "pointer",
                                                        mt: 1,
                                                    }}
                                                />
                                            </Tooltip>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Label>Assigned Process<sup style={{ color: "red" }}>*</sup></Form.Label>
                                    </td>
                                    <td style={{ width: "100%" }}>
                                        <Select menuPlacement="auto"
                                            blurInputOnSelect={false}
                                            className="basic-single"
                                            classNamePrefix="select"
                                            value={newAssignedProcess}
                                            isMulti
                                            isSearchable={true}
                                            name="Department"
                                            styles={Constants.Styles}
                                            menuPortalTarget={document.body}
                                            options={processOptions}
                                            onChange={(selectedOption) => {
                                                setNewAssignedProcess(selectedOption);
                                            }}
                                        />
                                    </td>
                                    <td>
                                        {showProcessGroupLoadSpinner ? (
                                            <CircularProgress
                                                size="1em"
                                                sx={{ mt: 1.5, ml: 0.7 }}
                                            />
                                        ) : (
                                            <Tooltip title="Reload">
                                                <RefreshOutlinedIcon
                                                    color="primary"
                                                    fontSize="medium"
                                                    onClick={() => getAllProcessGroup()}
                                                    sx={{
                                                        cursor: "pointer",
                                                        mt: 1,
                                                    }}
                                                />
                                            </Tooltip>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                            </tbody>
                        </table>
                    </center>
                </Modal.Body>
                <Modal.Footer>
                    <LoadingButton
                        loading={loading}
                        loadingPosition="start"
                        startIcon={<SaveIcon />}
                        variant="contained"
                        onClick={() => saveData()}
                        disabled={buttonDisable()}
                        sx={{ mr: 1 }}
                    >
                        Save
                    </LoadingButton>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={handleClose}
                        disabled={loading}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </Box>
    );

};

export default AddMfgUserProcessModal;

